function AboutUsModel({ id, address, phone, email, }) {
  let obj = {};
  obj.id = id;
  obj.address = address;
  obj.phone = phone;
  obj.email = email;
  return obj;
}

export default AboutUsModel;